module.exports = __webpack_public_path__ + "static/blue-wyrmling-1e9cea71d93457e01bb6c4097fbf2bad.png";